// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__3OY_Q"};